import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import koTranslations from './locales/ko.json'
import enTranslations from './locales/en.json'

const resources = {
  ko: {
    translation: koTranslations,
  },
  en: {
    translation: enTranslations,
  },
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ko', // 기본 언어
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false, // React는 기본적으로 XSS 보호를 제공
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  })

export default i18n